import { AssetsCode } from "@gtpl/shared-models/common-models";
import { Column, Entity, PrimaryGeneratedColumn, VersionColumn, UpdateDateColumn, CreateDateColumn, OneToMany } from "typeorm";
import { AssetsCatagory } from "../assets-catagory/assets-catagory-entity";
import { Assets } from "../open-assets/open-assets-entity";

@Entity('assetsClassification')
export class AssetsClassification {

    @PrimaryGeneratedColumn("increment", { name: 'assets_classification_id' })
    assetsClassificationId?: number;

    @Column("varchar", {
        nullable: false,
        length: 20,
        name: "assets_classification_name"
    })
    assetsClassificationName: string;

    @Column({
        type: 'enum',
        enum: AssetsCode,
        nullable: true,
        default: AssetsCode.REQUIRED,
        name: 'asset_code_required'
    })
    assetCodeRequired: AssetsCode;

    @Column("varchar", {
        nullable: true,
        length: 30,
        name: "assets_classification_code"
    })
    assetsClassificationCode: string;



    @Column("boolean", {
        nullable: false,
        name: "isActive",
        default: true
    })
    isActive: boolean | null;

    @CreateDateColumn({
        name: "created_at",
        type: "datetime"
    })
    createdAt: Date;

    @Column("varchar", {
        nullable: false,
        name: "created_user",
        length: 50
    })
    createdUser: string | null;


    @UpdateDateColumn({
        name: "updated_at",
        type: 'datetime'
    })
    updatedAt: Date;

    @Column("varchar", {
        nullable: true,
        name: "updated_user",
        length: 50
    })
    updatedUser: string | null;

    @VersionColumn({
        default: 1,
        name: "version_flag"
    })
    versionFlag: number;

    @OneToMany(type => AssetsClassification, assetsClassification => assetsClassification.assetsCatagoryInfo)
    assetsCatagoryInfo: AssetsCatagory[];

    @OneToMany((type) => AssetsClassification, (assetsClassificaion) => assetsClassificaion.openAssetsInfo)
    openAssetsInfo: Assets[];
}